import { UploadImageCard } from "components/UploadImageCard"
import { UICustomizationData } from "pages/UICustomization/types.ts"
import { useTranslation } from "react-i18next"
import { Box, Typography } from "@strapi/design-system"

interface UICustomizationLogoProps {
  data: UICustomizationData
  onChange: (data: UICustomizationData) => void
}

const logosTemplate = (t: (key: string) => string) => [
  {
    title: t("uiCustomizationLogo.mainLogo"),
    key: "main",
    widthToHeightRatio: 4,
  },
  {
    title: t("uiCustomizationLogo.shortLogo"),
    key: "short",
    widthToHeightRatio: 1,
  },
]

const LogoExample = ({ width, height, text }: { width: number; height: number; text: string }) => (
  <Box
    style={{
      width,
      height,
      background: "#333",
      color: "#fff",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      textAlign: "center",
      border: "2px solid #888",
    }}
  >
    {text}
    <br />
    {width / height}:1
  </Box>
)

export const UICustomizationLogo = ({ data, onChange }: UICustomizationLogoProps) => {
  const { t } = useTranslation()
  const template = logosTemplate(t)
  return (
    <div className={"flex flex-col gap-4"}>
      <div>
        <Typography variant="beta">{t("uiCustomizationLogo.customizationLogo")}</Typography>
        <Box padding={1} />
        <Typography variant="omega" textColor="neutral600">
          {t("uiCustomizationLogo.description")}
        </Typography>
        <Box
          paddingTop={2}
          style={{
            display: "flex",
            gap: "1rem",
          }}
        >
          <LogoExample width={512} height={128} text={t("uiCustomizationLogo.mainLogoExample")} />
          <LogoExample width={128} height={128} text={t("uiCustomizationLogo.shortLogoExample")} />
        </Box>
      </div>
      <div className="flex flex-row gap-4 mt-20 items-start">
        {template.map(({ title, key, widthToHeightRatio }) => (
          <UploadImageCard
            key={key}
            title={title}
            widthToHeightRatio={widthToHeightRatio}
            src={data.logos[key]}
            onChange={(image, base64) =>
              onChange({
                ...data,
                logos: {
                  ...data.logos,
                  [key]: image,
                  [`${key}Base64`]: base64,
                },
              })
            }
          />
        ))}
      </div>
    </div>
  )
}
